import styled from 'styled-components';
import { grey80, grey40 } from 'Styles/colors';
import { fontTitle, fontBody } from 'Styles/fonts';
import IconOriginal from '../../../Icons/Icon';
import InfoDialogOriginal from '../../../InfoDialog/InfoDialog';

export const FreeShippingUpsell = styled.div``;

export const Icon = styled(IconOriginal)`
  margin-right: 16px;
  font-size: 18px;
  width: 32px;
  text-align: center;
`;

export const Title = styled.h2`
  ${fontTitle(15)};
  margin: 0;
  padding: 0;
`;

export const SubTitle = styled.p`
  ${fontBody(14)};
  margin: 0;
  padding: 0;
`;

export const Button = styled.button`
  cursor: pointer;
  background: none;
  border: 0;
  padding: 0;
  margin: 0;
  text-decoration: underline;
`;

export const InfoDialog = styled(InfoDialogOriginal)`
  ${fontBody(12)}
  color: ${grey80};
  text-decoration: none;
  padding: 0;
  min-width: auto;
`;

export const Divider = styled.div`
  &:last-of-type {
    display: none;
  }

  border: 1px solid ${grey40};
  width: 100%;
  margin: 0;
  height: 0;
`;
